export default "__VITE_ASSET__edd41613__"